function PreSubmitKenticoForm(target) {
    let form = document.querySelector('form[id*="form-ERTS2020"]');
    SubmitKenticoForm(form);
}

function SubmitKenticoForm(event) {
    var form = event;
    let responsibleDetails = document.querySelector('[name*=".ResponsibleAdditionalDetails."]');
    if (responsibleDetails)
        responsibleDetails.value = CKEDITOR.instances[responsibleDetails.id].getData();

    let additionalDetails = document.querySelector('[name*=".AdditionalDetails."]');
    if (additionalDetails)
        additionalDetails.value = CKEDITOR.instances[additionalDetails.id].getData();

    var formData = new FormData(form);

    var onResponse = function (event) {
        var contentType = event.target.getResponseHeader("Content-Type");

        if (contentType.indexOf("application/json") === -1) {
            let replaceTarget = form.getAttribute("data-ktc-ajax-update");
            let element = document.createElement('div');
            let ertsGeneralError = document.getElementById('ertsGeneralError');
            element.innerHTML = event.target.response;
            if (element.querySelector('form[id*="form-ERTS2020"]')) {
                $(`#${replaceTarget}`).replaceWith(event.target.response);
                ertsGeneralError.classList.add('d-block');
                ertsGeneralError.classList.remove('d-none');
                $(window).scrollTop(ertsGeneralError);
                InitializeCKEditor();
            }
            else {
                replaceTarget = document.querySelector('div[id*="form-ERTS2020"]');
                ertsGeneralError.classList.remove('d-block');
                ertsGeneralError.classList.add('d-none');
                replaceTarget.innerHTML = event.target.response;
                $(window).scrollTop();
            }
        } else {
            ertsGeneralError.classList.remove('d-block');
            ertsGeneralError.classList.add('d-none');
            var json = JSON.parse(event.target.response);
            location.href = json.redirectTo;
        }
    };

    createRequest(form, formData, onResponse);
}

function createRequest(form, formData, onResponse) {
    var xhr = new XMLHttpRequest();

    xhr.addEventListener("load", onResponse);

    xhr.open("POST", form.action);
    xhr.send(formData);
}

function InitializeCKEditor() {
    let responsibleDetails = document.querySelector('[name*=".ResponsibleAdditionalDetails."]');
    if (responsibleDetails) {
        CKEDITOR.replace(responsibleDetails.id, {
            toolbar:
                [
                    ['Bold', 'Italic', 'Blockquote', '-', 'NumberedList', 'BulletedList', '-', 'Link', 'Unlink']
                ],
            resize_enabled: true
        });
    }

    let additionalDetails = document.querySelector('[name*=".AdditionalDetails."]');
    if (additionalDetails) {
        CKEDITOR.replace(additionalDetails.id, {
            toolbar:
                [
                    ['Bold', 'Italic', 'Blockquote', '-', 'NumberedList', 'BulletedList', '-', 'Link', 'Unlink']
                ],
            resize_enabled: true
        });
    }
}

function SelfReportingHandler(target) {
    if (target.value == "Yes") {
        let ResponsibleFirstName = document.querySelector('[name*=".ResponsibleFirstName."]');
        let ReporterFirstName = document.querySelector('[name*=".ReporterFirstName."]');
        ResponsibleFirstName.value = ReporterFirstName.value;

        let ResponsibleLastName = document.querySelector('[name*=".ResponsibleLastName."]');
        let ReporterLastName = document.querySelector('[name*=".ReporterLastName."]');
        ResponsibleLastName.value = ReporterLastName.value;

        let ResponsibleOrganization = document.querySelector('[name*=".ResponsibleOrganization."]');
        let ReporterOrganization = document.querySelector('[name*=".ReporterOrganization."]');
        ResponsibleOrganization.value = ReporterOrganization.value;

        let ResponsibleEmail = document.querySelector('[name*=".ResponsibleEmail."]');
        let ReporterEmail = document.querySelector('[name*=".ReporterEmail."]');
        ResponsibleEmail.value = ReporterEmail.value;

        let ResponsiblePhone = document.querySelector('[name*=".ResponsiblePhone."]');
        let ReporterPhoneNumber1 = document.querySelector('[name*=".ReporterPhoneNumber1."]');
        ResponsiblePhone.value = ReporterPhoneNumber1.value;

        let ResponsibleCountry = document.querySelector('[name*=".ResponsibleCountry."]');
        let ReporterCountry = document.querySelector('[name*=".ReporterCountry."]');
        ResponsibleCountry.value = ReporterCountry.value;

        let ResponsibleAddress1 = document.querySelector('[name*=".ResponsibleAddress1."]');
        let ReporterAddress1 = document.querySelector('[name*=".ReporterAddress1."]');
        ResponsibleAddress1.value = ReporterAddress1.value;

        let ResponsibleAddress2 = document.querySelector('[name*=".ResponsibleAddress2."]');
        let ReporterAddress2 = document.querySelector('[name*=".ReporterAddress2."]');
        ResponsibleAddress2.value = ReporterAddress2.value;

        let ResponsibleCity = document.querySelector('[name*=".ResponsibleCity."]');
        let ReporterCity = document.querySelector('[name*=".ReporterCity."]');
        ResponsibleCity.value = ReporterCity.value;

        let ResponsibleState = document.querySelector('[name*=".ResponsibleState."]');
        let ReporterState = document.querySelector('[name*=".ReporterState."]');
        ResponsibleState.value = ReporterState.value;

        let ResponsibleZipCode = document.querySelector('[name*=".ResponsibleZipCode."]');
        let ReporterZipCode = document.querySelector('[name*=".ReporterZipCode."]');
        ResponsibleZipCode.value = ReporterZipCode.value;
    } else {
        let ReporterFirstName = document.querySelector('[name*=".ReporterFirstName."]');
        ReporterFirstName.value = '';

        let ReporterLastName = document.querySelector('[name*=".ReporterLastName."]');
        ReporterLastName.value = '';

        let ReporterOrganization = document.querySelector('[name*=".ReporterOrganization."]');
        ReporterOrganization.value = '';

        let ReporterEmail = document.querySelector('[name*=".ReporterEmail."]');
        ReporterEmail.value = '';

        let ReporterPhoneNumber1 = document.querySelector('[name*=".ReporterPhoneNumber1."]');
        ReporterPhoneNumber1.value = '';

        let ReporterCountry = document.querySelector('[name*=".ReporterCountry."]');
        ReporterCountry.value = '';

        let ReporterAddress1 = document.querySelector('[name*=".ReporterAddress1."]');
        ReporterAddress1.value = '';

        let ReporterAddress2 = document.querySelector('[name*=".ReporterAddress2."]');
        ReporterAddress2.value = '';

        let ReporterCity = document.querySelector('[name*=".ReporterCity."]');
        ReporterCity.value = '';

        let ReporterState = document.querySelector('[name*=".ReporterState."]');
        ReporterState.value = '';

        let ReporterZipCode = document.querySelector('[name*=".ReporterZipCode."]');
        ReporterZipCode.value = '';
    }
}


document.addEventListener("DOMContentLoaded", function (event) {
    InitializeCKEditor();
});